import { StoreExt } from '@utils/reactExt'
import { action, observable } from 'mobx'
import { MarketTrack } from '@store/matchupStore'


export class MarketTooltipStore extends StoreExt {

  // 툴팁 활성화 여부
  // key : accordionKey
  // value : 툴팁 활성화 여부
  @observable
  marketTooltips: { [id: string]: boolean }

  // 추가벳 클릭해서 열려있는 상태의 키들
  selectedActiveKeys: any[]

  constructor() {
    super()
    this.cleanup()
  }

  @action
  cleanup = () => {
    this.marketTooltips = {}
    this.selectedActiveKeys = []
  }

  getMarketTooltipKey = (market: MarketTrack) => {
    return market.name
  }

  getExcludeKey = (newKeys) => {
    for (const key of this.selectedActiveKeys) {
      const indexOf = newKeys.indexOf(key)
      if (indexOf === -1) {
        const findIndexOf = this.findIndexSelectedActiveKey(key)
        if (findIndexOf !== -1) {
          this.popSelectedActiveKey(findIndexOf)
          return key
        }
      }
    }

    return ''
  }

  @action
  getActiveTooltip = (market: MarketTrack): boolean => {
    const tooltipKey = this.getMarketTooltipKey(market)
    if (this.marketTooltips === undefined) {
      return false
    }

    return this.marketTooltips[tooltipKey]
  }

  @action
  setActiveTooltip = (market: MarketTrack, active: boolean) => {
    const tooltipKey = this.getMarketTooltipKey(market)
    this.marketTooltips[tooltipKey] = active
  }

  findIndexSelectedActiveKey = (key) => {
    return this.selectedActiveKeys.indexOf(key)
  }

  pushSelectedActiveKey = (key) => {
    const indexOf = this.findIndexSelectedActiveKey(key)
    if (indexOf === -1) {
      this.selectedActiveKeys.push(key)
    }
  }

  popSelectedActiveKey = (activeKeyIndex: number) => {
    this.selectedActiveKeys.splice(activeKeyIndex, 1)
  }

  @action
  updateMarketTooltips = (markets: MarketTrack[]) => {
    for (const market of markets) {
      const tooltipKey = this.getMarketTooltipKey(market)
      if (this.marketTooltips[tooltipKey] === undefined) {
        this.marketTooltips[tooltipKey] = false
      }
    }
  }
}

export default new MarketTooltipStore()
